import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PipesModule } from '../../../common/pipes/pipes.module';
import { AttachmentPlaceloaderComponent } from './attachment-placeloader.component';

@NgModule({
  exports: [AttachmentPlaceloaderComponent],
  imports: [CommonModule, PipesModule, AttachmentPlaceloaderComponent],
})
export class AttachmentPlaceloaderModule {}

export { AttachmentPlaceloaderComponent };
export { AttachmentPlaceloader } from './attachment-placeloader.types';
